import { Routes } from '@angular/router';
import { DynamicContentPage } from './pages/dynamic-content.page';

export const routes: Routes = [
	{
		path: ':path',
		component: DynamicContentPage,
	},
	{
		path: '**',
		component: DynamicContentPage,
	},
];
